import { useState, useEffect, FC } from 'react';
import { Form } from 'rsuite';
import { RsSelect } from 'components/Rsuite/Select';
// import { CreativeType } from 'core/creative/Creative';
import ImageForm from './Components/ImageForm';
import ProductNativeForm from './Components/ProductNativeForm';
import RichProductNativeForm from './Components/RichProductNativeForm';
import ShopForm from './Components/ShopForm';
import useCreativeStore from 'store/creativeStore';
import ProductManager from '../ProductManager/ProductManager';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { useCampaignStore } from 'store/campaignStore';
import { useProductStore } from 'store/productStore';

interface CreativeFormProps {
  campaignId: string;
}

const CreativeForm: FC<CreativeFormProps> = ({ campaignId }) => {
  const { adType: campaignAdtype } = useCampaignStore();
  const { actionType, creative, creativesPermission } = useCreativeStore();
  const { resetProductStore } = useProductStore();

  const [adType, setAdType] = useState<number | null>(
    creative?.creativeType || 0,
  );

  const creativeTypeOptions = () => {
    switch (campaignAdtype) {
      case AdType.DISPLAY:
        return [
          { value: 0, label: '請選擇' },
          { value: 1, label: '圖像式素材' },
          { value: 9, label: '原生商品素材' },
          { value: 12, label: '圖像加商品素材' },
        ];
      case AdType.SHOP:
        return [{ value: 14, label: '黃金置頂素材' }];
      default:
        return [
          { value: 0, label: '請選擇' },
          { value: 1, label: '圖像式素材' },
        ];
    }
  };

  // creativesPermission => 控制供應商有權限使用的素材類型
  // 用 creativesPermission 判斷目前登入人員可使用那些哪些素材類型
  const handlePreProcessCreativeTypeOptions = (creativeTypeOptions) => {
    return creativeTypeOptions.filter(
      (option) =>
        creativesPermission[`option_${option.value}`] || option.value === 0,
    );
  };

  const renderCreativeForm = () => {
    switch (adType) {
      case 1:
        return <ImageForm campaignId={campaignId} />;
      case 9:
        return <ProductNativeForm campaignId={campaignId} />;
      case 12:
        return <RichProductNativeForm campaignId={campaignId} />;
      case 14:
        return <ShopForm campaignId={campaignId} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (campaignAdtype === AdType.SHOP) {
      setAdType(14);
    }
    return () => {
      resetProductStore();
    };
  }, [campaignAdtype]);

  return (
    <Form fluid layout='horizontal' className='h-full pb-4'>
      <Form.Group controlId='adType'>
        <Form.ControlLabel>素材類型</Form.ControlLabel>
        <RsSelect
          data={handlePreProcessCreativeTypeOptions(creativeTypeOptions())}
          value={adType}
          searchable={false}
          onChange={setAdType}
          className='w-[150px]'
          cleanable={false}
          disabled={actionType === 'edit' || campaignAdtype === AdType.SHOP}
        />
      </Form.Group>
      {renderCreativeForm()}

      <ProductManager
        singleSelect={adType === 1 || adType === 14}
        enableCreateProductNativeCreative={true}
        showImportButton={false}
      />
    </Form>
  );
};

export default CreativeForm;
